import React from 'react';
import Filters from '../Filters';
import PropTypes from 'prop-types';
import Select from 'react-select';

import './FilterDate.css';
import 'react-select/dist/react-select.css';

export default class FilterDate extends Filters {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={`FilterDate ${this.props.className ? this.props.className : ''}`}>
        <Select
          name="form-field-name"
          value={this.props.value}
          placeholder="Filter"
          className="select"
          onChange={this.props.onChange}
          clearable={false}
          options={[
            { value: 'today', label: 'Today'      },
            { value: 'week' , label: 'This Week'  },
            { value: 'month', label: 'This Month' },
            { value: 'year' , label: 'This Year'  },
          ]}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/FilterDateComponent/FilterDate.js